import React, { useState } from "react";
import { FaRegChartBar, FaTh } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { IoSearch } from "react-icons/io5";
import { TbLayoutSidebarLeftCollapse, TbLayoutSidebarLeftExpand, TbLogout2 } from "react-icons/tb";
import { GrDocumentConfig } from "react-icons/gr";
import { LiaPalletSolid } from "react-icons/lia";
import { RiBardLine, RiSettings2Line } from "react-icons/ri";
import logo from "../assets/images/logoipsum.svg";
import { useAuth } from "../pages/auth/AuthContext";
import "./styles/sidebar.css";

const privilegedMenuItems = [
  { path: "/", name: "Dashboard", icon: <FaTh /> },
  { path: "/searchtool", name: "Search Tool", icon: <IoSearch /> },
  { path: "/reports", name: "Reports", icon: <FaRegChartBar /> },
  { path: "/bidding-sheet", name: "Bidding Sheet", icon: <GrDocumentConfig /> },
  { path: "/pallets", name: "Pallets", icon: <LiaPalletSolid /> },
  { path: "/feature-suggestion", name: "Suggest a Feature", icon: <RiBardLine /> },
  { path: "/settings", name: "Settings", icon: <RiSettings2Line /> },
];

const regularMenuItems = [
  { path: "/manager-dashboard", name: "Dashboard", icon: <FaTh /> },
];

const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { logout } = useAuth();
  const staffUser = localStorage.getItem("staff_user");
  const admin = localStorage.getItem("admin");
  const username = localStorage.getItem("username") || "User";
  const canManageInventory = admin === "true" || staffUser === "true";
  const menuItems = canManageInventory ? privilegedMenuItems : regularMenuItems;
  const displayName = username.charAt(0).toUpperCase() + username.slice(1);
  const initial = username.charAt(0).toUpperCase();

  const closeOnMobile = () => {
    if (window.innerWidth <= 768) setIsOpen(false);
  };

  return (
    <div className="app-shell">
      {isOpen && (
        <button
          type="button"
          className="sidebar-backdrop"
          aria-label="Close navigation"
          onClick={() => setIsOpen(false)}
        />
      )}

      <aside className={`sidebar ${isOpen ? "open" : "closed"}`}>
        <div className="sidebar-main">
          <div className="top_section">
            <img className="logo" src={logo} alt="Bestcash" />
            <button
              type="button"
              className="bars"
              onClick={() => setIsOpen((open) => !open)}
              aria-label={isOpen ? "Collapse navigation" : "Expand navigation"}
              aria-expanded={isOpen}
            >
              {isOpen ? <TbLayoutSidebarLeftCollapse /> : <TbLayoutSidebarLeftExpand />}
            </button>
          </div>

          <nav className="sidebar-nav" aria-label="Primary navigation">
            {menuItems.map((item) => (
              <NavLink
                to={item.path}
                end={item.path === "/"}
                key={item.path}
                className={({ isActive }) => `link${isActive ? " active" : ""}`}
                onClick={closeOnMobile}
                data-label={item.name}
                title={!isOpen ? item.name : undefined}
              >
                <span className="icon">{item.icon}</span>
                <span className="link_text">{item.name}</span>
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="sidebar-footer">
          <div className="user-container">
            <span className="user-avatar" aria-hidden="true">{initial}</span>
            <span className="user-name">{displayName}</span>
          </div>
          <NavLink
            to="/login"
            className="link-logout"
            onClick={logout}
            data-label="Log out"
            title={!isOpen ? "Log out" : undefined}
          >
            <span className="icon"><TbLogout2 /></span>
            <span className="link_text">Log out</span>
          </NavLink>
        </div>
      </aside>

      <main className="app-content">{children}</main>
    </div>
  );
};

export default Sidebar;
